import Swal from 'sweetalert2'
import bcrypt from 'bcryptjs'
import { useEffect } from 'react'

const Login = ({ loggedIn, setLoggedIn }) => {
  function setSecureCookie(name, value) {
    const expires = new Date()
    // Set the expiration time to 10 days from now
    expires.setTime(expires.getTime() + 10 * 24 * 60 * 60 * 1000)

    // Construct the cookie string
    const cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/;`

    // Set the cookie
    document.cookie = cookieString
  }

  const showLoginAlert = (message = null) => {
    Swal.fire({
      title: 'Login',
      html: `
        ${message ? `<p style="color: red; font-size: 14px; margin-bottom: 10px;">${message}</p>` : ''}
        <input type="text" id="username" class="swal2-input" placeholder="Username">
        <input type="password" id="password" class="swal2-input" placeholder="Password">
      `,
      confirmButtonText: 'Submit',
      focusConfirm: false,
      allowOutsideClick: false, // Prevent closing by clicking outside
      allowEscapeKey: false, // Prevent closing by pressing ESC
      preConfirm: () => {
        const username = Swal.getPopup().querySelector('#username').value
        const password = Swal.getPopup().querySelector('#password').value
        if (!username || !password) {
          Swal.showValidationMessage(`Please enter username and password`)
        }

        return { username, password }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { username, password } = result.value
        if (username === import.meta.env.VITE_USERNAME) {
          // Compare provided password with stored hashed password
          const isPasswordValid = bcrypt.compareSync(password, import.meta.env.VITE_HASH_PASSWORD)

          if (isPasswordValid) {
            // Create JWT token
            setSecureCookie('user', username)

            Swal.fire({
              icon: 'success',
              title: 'Login Successful',
              confirmButtonText: 'OK',
            }).then(() => {
              setLoggedIn(true) // Update parent state
            })
          } else {
            showLoginAlert('Invalid username or password')
          }
        } else {
          showLoginAlert('Invalid username or password')
        }
      }
    })
  }

  useEffect(() => {
    if (loggedIn == false) showLoginAlert()
  }, [loggedIn])
}

export default Login
